import type { ReactNode } from 'react';
import Footer from './Footer';
import Header from './Header';
import SkipLink from './SkipLink';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <SkipLink />
      <Header />
      <main className="hp-main" id="main" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </>
  );
}
